var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.46205 0H13.6196C13.9374 0 14.195 0.262344 14.195 0.585938V19.4141C14.195 19.7377 13.9374 20 13.6196 20H0.575474C0.257659 20 0 19.7377 0 19.4141V3.525C0 3.36961 0.060655 3.22055 0.168576 3.11066L3.05515 0.171641C3.16308 0.0617187 3.30944 0 3.46205 0ZM5.94657 9.80469H2.87737C2.55956 9.80469 2.3019 10.067 2.3019 10.3906C2.3019 10.7142 2.55956 10.9766 2.87737 10.9766H5.94657C6.26438 10.9766 6.52204 10.7142 6.52204 10.3906C6.52204 10.067 6.26438 9.80469 5.94657 9.80469ZM11.3177 16.8359H8.24847C7.93065 16.8359 7.67299 16.5736 7.67299 16.25C7.67299 15.9264 7.93065 15.6641 8.24847 15.6641H11.3177C11.6355 15.6641 11.8931 15.9264 11.8931 16.25C11.8931 16.5736 11.6355 16.8359 11.3177 16.8359ZM2.87737 13.9062H11.3177C11.6355 13.9062 11.8931 13.6439 11.8931 13.3203C11.8931 12.9967 11.6355 12.7344 11.3177 12.7344H2.87737C2.55956 12.7344 2.3019 12.9967 2.3019 13.3203C2.3019 13.6439 2.55956 13.9062 2.87737 13.9062Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.33dd18e2.svg";
export { ForwardRef as ReactComponent };